import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Stackfeebackyeppy = () => {
  return (
    <div className="stackfeeback_yeppy p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>Stakeholder feedback (Client, PM, BA)</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="stack_feedback_box">
              <div className="stack_feedback_img_circle">
                <StaticImage
                  src="../../../images/case-studies/yeppy/stack_colon.png"
                  alt="TekRevol"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={67}
                />
                <h5>Client</h5>
              </div>
              <div className="stack_feedback_content">
                <p>
                  “We are extremely pleased with TekRevol for their exceptional
                  work on the super app, Yeppy. The quality of the app and the
                  way it caters to our target audience's needs is truly
                  impressive. We look forward to a continued partnership and
                  more exciting projects together.”
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="stack_feedback_box">
              <div className="stack_feedback_img_circle">
                <StaticImage
                  src="../../../images/case-studies/yeppy/stack_colon.png"
                  alt="TekRevol"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={67}
                />
                <h5>Project Manager</h5>
              </div>
              <div className="stack_feedback_content">
                <p>
                  “I'd like to extend my appreciation to our client for their
                  vision and collaboration throughout this project. Their
                  valuable insights and clear communication have played a
                  pivotal role in the success of the application,
                  <span>Yeppy</span>.”
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="stack_feedback_box">
              <div className="stack_feedback_img_circle">
                <StaticImage
                  src="../../../images/case-studies/yeppy/stack_colon.png"
                  alt="TekRevol"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={67}
                />
                <h5>Business Analyst</h5>
              </div>
              <div className="stack_feedback_content">
                <p>
                  “The client's input and requirements were invaluable in
                  shaping the super app's features and functionalities. Their
                  detailed understanding of the market and user needs greatly
                  assisted our development team in delivering a top-notch
                  product. We're grateful for their proactive involvement, which
                  contributed to the app's success!”
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="stack_feedback_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/stack_holder.png"
                alt="TekRevol"
                className="img-fluid d-none d-md-block"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1561}
              />
              <StaticImage
                src="../../../images/case-studies/yeppy/feedback_img_mob.png"
                alt="TekRevol"
                className="img-fluid d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1386}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Stackfeebackyeppy;
